const asComparableString = (value) => (value == null ? "" : String(value));

const parseStandardAiFunctions = (value) => {
  let source = value;
  if (typeof value === "string") {
    try {
      source = JSON.parse(value);
    } catch (e) {
      source = [];
    }
  }

  return Array.isArray(source)
    ? source.filter((item) => typeof item === "string")
    : [];
};

export const normalizeStandardAiFunctions = (value) =>
  parseStandardAiFunctions(value).filter((item) => item !== "show_url_popup");

const serializeStandardAiFunctions = (value) =>
  JSON.stringify(normalizeStandardAiFunctions(value));

const hasLegacyStandardAiFunction = (value) =>
  parseStandardAiFunctions(value).includes("show_url_popup");

export const serializeStandardAiFunctionsForCreate = (value) => {
  const normalizedFunctions = normalizeStandardAiFunctions(value);
  return normalizedFunctions.length > 0
    ? JSON.stringify(normalizedFunctions)
    : null;
};

export const addChangedStandardAiFunctionsField = (
  payload,
  standardAiFunctions,
  existingBusiness = {}
) => {
  const nextValue = serializeStandardAiFunctions(standardAiFunctions);
  const existingValue = serializeStandardAiFunctions(
    existingBusiness.standard_ai_functions
  );

  if (
    nextValue !== existingValue ||
    hasLegacyStandardAiFunction(existingBusiness.standard_ai_functions)
  ) {
    payload.standard_ai_functions = nextValue;
  }

  return payload;
};

export const nullIfEmptyBusinessField = (value) => {
  const normalizedValue = asComparableString(value);
  return normalizedValue === "" ? null : normalizedValue;
};

const addChangedStringField = (payload, targetKey, nextValue, existingValue) => {
  const normalizedNextValue = asComparableString(nextValue);
  if (normalizedNextValue !== asComparableString(existingValue)) {
    payload[targetKey] = normalizedNextValue;
  }
};

export const addChangedLargeBusinessFields = (
  payload,
  { systemPrompt, functionsJson, rivetYaml, themeLogo },
  existingBusiness = {}
) => {
  addChangedStringField(
    payload,
    "system_prompt",
    systemPrompt,
    existingBusiness.system_prompt
  );
  addChangedStringField(
    payload,
    "functions_json",
    functionsJson,
    existingBusiness.functions_json
  );
  addChangedStringField(
    payload,
    "rivet_yaml",
    rivetYaml,
    existingBusiness.rivet_yaml
  );
  addChangedStringField(
    payload,
    "themeLogo",
    themeLogo,
    existingBusiness.themeLogo
  );

  return payload;
};
